'use client';

import { Close } from '@1debit/icons';
import Button from 'components/shared/Buttons/BaseButton';
import Link from 'components/shared/Link/Link';
import { FeaturedBannerProps } from 'libs/contentful/props';
import { useState } from 'react';
import { setCookie } from 'cookies-next';
import { getColorway } from 'utils/styles';
import { createCookieOptions, CookieOptions } from 'utils/cookies';

const setBannerDismissalCookie = (bannerKey: string): void => {
  // Create expiration date (30 days)
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);

  const commonOptions: CookieOptions = createCookieOptions({
    cookieOptions: { expires },
  });

  setCookie(bannerKey, 'dismissed', commonOptions);
};

export const FeaturedBanner = ({ sys, text, color, cta, ctaAsButton, showCloseButton }: FeaturedBannerProps) => {
  const [dismissed, setDismissed] = useState(false);
  const bannerKey = 'banner-' + sys?.id;

  const handleDismiss = () => {
    setDismissed(true);
    setBannerDismissalCookie(bannerKey);
  };

  if (dismissed) return null;

  return (
    <div className={getColorway(color)} data-testid="featuredBanner">
      <div className="content-wrapper flex justify-between items-center py-2 gap-6">
        <div className="flex gap-4 items-center flex-1">
          <p className="font-sans text-label-saans max-sm:leading-tight" data-testid="featuredBannerText">
            {text}
          </p>
          {cta &&
            (!ctaAsButton ? (
              <Link
                href={cta.url}
                target={cta.target}
                className="text-sm font-sans font-semibold underline flex gap-2"
                iconProps={{ icon: 'arrow_right', position: 'trailing' }}
                data-testid="featuredBannerLink">
                {cta.label}
              </Link>
            ) : (
              <Button
                href={cta.url}
                variant="outline"
                className="max-sm:min-w-fit max-sm:max-w-[116px] max-sm:py-1.5 min-w-[150px] max-h-10 w-fit"
                testId="featuredBannerButton">
                {cta.label}
              </Button>
            ))}
        </div>
        {showCloseButton && (
          <button
            // featured-banner-close is required for Google Tag Manager event tracking
            className="hover:cursor-pointer featured-banner-close"
            onClick={handleDismiss}
            data-testid="featuredBannerClose">
            <span className="sr-only">Close banner</span>
            <Close size={24} className="pointer-events-none" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FeaturedBanner;
